import React from 'react';
  
const Reviews = () => {
    console.log("hello")
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'Center',
        height: '90vh'
      }}
    >
      <h1>reviews for geni's tailor shop</h1>
    </div>
  );
};
  
export default Reviews;